// Single source for the request auth header. Functions, not constants: the
// token is read from localStorage at call time so it always reflects the
// current session (it changes on login / logout / expiry).
//
//   authHeaders() -> a full axios config object:  axios.get(url, authHeaders())
//   authHeader()  -> just the header entry, to spread into a fetch() init:
//                    fetch(url, { method, headers: { ...authHeader() }, body })

export const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

export const authHeaders = () => ({ headers: authHeader() });
